export default __webpack_public_path__ + "static/media/signup-page.e6910019.jpg";